import { loc } from "../../../core/utils"
import * as yup from "yup"

const wrongFileExtensionMessage = () => loc("wrongFileExtensionMessage")
const fiveMegaBytesMaximumFileMessage = () => loc("fiveMegaBytesMaximumFileMessage")

const validExtensions = ["jpeg", "JPEG", "JPG", "jpg", "pdf", "PDF"]
const FIVE_MEGABYTES = 5120 // 5MB

let schema = yup.object().shape({
  documentPages: yup
    .array()
    .min(1)
    .of(
      yup.mixed().test({
        name: "document",
        message: "",
        test(value) {
          const file = value?.file
          const fileExtension = file?.type?.split("/")[1]
          const fileSize = file?.size
          const fileSizeKiloBytes = fileSize / 1024

          if (!validExtensions.includes(fileExtension)) {
            return this.createError({
              message: wrongFileExtensionMessage,
              path: `${this.options.path}`
            })
          }

          if (fileSizeKiloBytes >= FIVE_MEGABYTES) {
            return this.createError({
              message: fiveMegaBytesMaximumFileMessage,
              path: `${this.options.path}`
            })
          }
        }
      })
    )
})

export default (values) => {
  return schema.validate(values, { abortEarly: false, context: values })
}
